import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelInlineItem, PsapView } from '@/ui';
import type { AdditionalIncidentData, Dispatcher } from '@/signalr';
import { ALL_ATE_PSAP_IDS } from '../../model/psapConfiguration';
import { DispatcherNotePanel } from '../DispatcherNotePanel';
import { AdditionalIncidentDataPanelItem } from './AdditionalIncidentDataPanelItem';
import { IncidentLabelPanelItem } from './IncidentLabelPanelItem';

export type AdditionalIncidentDataPanelProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  additionalIncidentData: AdditionalIncidentData;
  dispatcher: Dispatcher;
};

export function AdditionalIncidentDataPanel({
  incidentId,
  incidentIsReadOnly,
  additionalIncidentData,
  dispatcher,
}: AdditionalIncidentDataPanelProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_AdditionalIncidentData_PanelHeader')}>
      <IncidentLabelPanelItem
        incidentId={incidentId}
        incidentLabel={additionalIncidentData.incidentLabel}
        incidentIsReadOnly={incidentIsReadOnly}
      />

      <AdditionalIncidentDataPanelItem
        incidentId={incidentId}
        callSign={additionalIncidentData.callSign}
        incidentIsReadOnly={incidentIsReadOnly}
      />

      <DispatcherNotePanel incidentId={incidentId} note={dispatcher.note} incidentIsReadOnly={incidentIsReadOnly} />

      {additionalIncidentData.ateMessage != null && additionalIncidentData.ateMessage.trim() !== '' && (
        <PsapView psapIds={ALL_ATE_PSAP_IDS}>
          <DataPanelInlineItem title="ATE správa" value={additionalIncidentData.ateMessage} editable={false} showEmptyPlaceholder />
        </PsapView>
      )}
    </DataPanel>
  );
}
